define('components/course/models/slide-type/full-screen-video',[
    'components/course/models/slide-type/base'
], function (Base) {
    "use strict";

    return Base.extend({
        "defaults": function () {
            var baseDefaults = Base.prototype.defaults.call(this),
                defaults;

            defaults = {
                "data": {
                    "video": null
                }
            };

            return _.extend(baseDefaults, defaults);
        }
    });
});

